import { Globe } from "lucide-react";
import { FC, useContext } from "react";
import { FormattedMessage } from "react-intl";
import { LocalizationContext } from "~/components/LocalizationWrapper";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";

const languages = [
  { value: "en", labelId: "settings.englishLang", defaultMessage: "English" },
  { value: "fr", labelId: "settings.frenchLang", defaultMessage: "French" },
];

interface LanguageSelectorProps {
  variant?: "compact" | "full";
}

export const LanguageSelector: FC<LanguageSelectorProps> = ({
  variant = "compact",
}) => {
  const { locale, setLocale } = useContext(LocalizationContext);

  const handleLocaleChange = (newLocale: string) => {
    setLocale(newLocale);
  };

  if (variant === "compact") {
    return (
      <Select value={locale} onValueChange={handleLocaleChange}>
        <SelectTrigger className="w-[140px] h-9 border-border">
          <div className="flex items-center gap-2">
            <Globe className="h-4 w-4 text-foreground" />
            <SelectValue />
          </div>
        </SelectTrigger>
        <SelectContent>
          {languages.map(({ value, labelId, defaultMessage }) => (
            <SelectItem key={value} value={value}>
              <FormattedMessage id={labelId} defaultMessage={defaultMessage} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <div className="w-full flex flex-col gap-2">
      <span className="text-sm font-medium">
        <FormattedMessage id="settings.language" defaultMessage="Language" />
      </span>
      <Select value={locale} onValueChange={handleLocaleChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select a language" />
        </SelectTrigger>
        <SelectContent>
          {languages.map(({ value, labelId, defaultMessage }) => (
            <SelectItem key={value} value={value}>
              <FormattedMessage id={labelId} defaultMessage={defaultMessage} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
